import React from "react";
import CropPngFaq from "./CropPngFaq";
import CropPngFreeContent from "./CropPngFreeContent";
import { CropPngFreeWithOnline } from "./CropPngFreeWithOnline";

const CropPngPreToolsArea = () => {
    return (
        <div className="flex justify-center items-center-center content-center">
            <div className="max-w-4xl mx-5  md:mx-20">
                <CropPngFreeWithOnline />
                <CropPngFreeContent />
                <CropPngFaq />
            </div>
        </div>
    );
};

export default CropPngPreToolsArea;
